import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const pageTitles = {
  privacy: 'Datenschutzerklärung',
  terms: 'Allgemeine Geschäftsbedingungen',
  imprint: 'Impressum & Offenlegung',
};

const pageKickers = {
  privacy: 'Privacy / Transparency',
  terms: 'Clear Terms / Strong Work',
  imprint: 'Vienna / Austria',
};

export default function LegalPage() {
  const { page: paramPage } = useParams();
  const location = useLocation();

  const getPageFromPath = () => {
    const path = location.pathname.replace('/', '');
    if (path === 'privacy' || path === 'terms' || path === 'imprint') {
      return path;
    }
    return paramPage || 'privacy';
  };

  const page = getPageFromPath();
  const [content, setContent] = useState({ title: '', body: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, location.pathname]);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/legal/${page}`);
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      } else {
        setContent({
          title: pageTitles[page] || 'Seite',
          body: 'Inhalt folgt in Kürze …',
        });
      }
    } catch (error) {
      console.error('Error fetching content:', error);
      setContent({
        title: pageTitles[page] || 'Seite',
        body: 'Inhalt folgt in Kürze …',
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-foreground/20 border-t-brand rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground text-sm uppercase tracking-wider">Lädt</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <section className="pt-32 pb-20 md:pt-40 md:pb-32">
        <div className="container-custom max-w-5xl">
          <Reveal>
            <span className="kicker mb-6 inline-flex">{pageKickers[page] || 'Someones Direction'}</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-display text-4xl md:text-6xl text-foreground mb-12">
              {content.title || pageTitles[page]}
            </h1>
          </Reveal>

          <Reveal delay={0.2}>
            <div
              className="legal-prose"
              dangerouslySetInnerHTML={{ __html: content.body || '<p>Inhalt folgt in Kürze …</p>' }}
            />
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
